import { db, type Review } from './db';
import { api } from './api';
import { getNow } from '$lib/stores/adminTime';

export async function markPendingSync(scriptId: string): Promise<void> {
	const existing = await db.syncState.get(scriptId);
	await db.syncState.put({
		script: scriptId,
		lastSync: existing?.lastSync ?? '',
		pendingChanges: true,
	});
}

export async function syncToServer(force = false): Promise<void> {
	if (typeof navigator !== 'undefined' && !navigator.onLine) return;
	try {
		const syncStates = await db.syncState.toArray();

		for (const state of syncStates) {
			if (!force && !state.pendingChanges) continue;

			const reviews = await db.reviews.where('script').equals(state.script).toArray();

			const result = await api.sync.upload(state.script, reviews, state.lastSync) as { lastSync: string };

			await db.syncState.update(state.script, {
				lastSync: result?.lastSync ?? new Date().toISOString(),
				pendingChanges: false
			});
		}
	} catch (error) {
		console.error('Sync to server failed:', error);
	}
}

export async function syncFromServer(force = false): Promise<void> {
	if (typeof navigator !== 'undefined' && !navigator.onLine) return;
	try {
		const serverData = await api.sync.download() as Array<{
			script: string;
			reviews: Review[];
			lastSync: string;
		}>;

		for (const scriptData of serverData) {
			const localState = await db.syncState.get(scriptData.script);

			if (
				force ||
				!localState ||
				new Date(scriptData.lastSync) > new Date(localState.lastSync || 0)
			) {
				const existing = await db.reviews.where('script').equals(scriptData.script).toArray();
				const existingIds = new Set(existing.map(r => r.itemId));

				await db.reviews.bulkPut(scriptData.reviews);
				await db.syncState.put({
					script: scriptData.script,
					lastSync: scriptData.lastSync,
					pendingChanges: false
				});

				const today = getNow().toISOString().slice(0, 10);
				const newTodayCount = scriptData.reviews.filter(
					r => !existingIds.has(r.itemId) && r.lastReview?.startsWith(today)
				).length;

				if (newTodayCount > 0 && typeof localStorage !== 'undefined') {
					const storageKey = `grafem_intros_${scriptData.script}_${today}`;
					const local = parseInt(localStorage.getItem(storageKey) || '0', 10);
					localStorage.setItem(storageKey, String(local + newTodayCount));
				}
			}
		}
	} catch (error) {
		console.error('Sync from server failed:', error);
	}
}
